import React from "react";
import { Phone, Mail, MapPin, Clock, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { contactInfo } from "../data/mockData";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="text-2xl font-bold text-blue-400">PropertySellEasy</div>
            <p className="text-gray-300 leading-relaxed">
              Helping homeowners across America sell their properties quickly, easily, 
              and profitably through AI-powered offers and expert guidance.
            </p>
            <div className="text-sm text-gray-400">
              <p>Serving Nationwide</p>
            </div>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#how-it-works" className="text-gray-300 hover:text-white transition-colors">How It Works</a></li>
              <li><a href="#calculator" className="text-gray-300 hover:text-white transition-colors">Offer Calculator</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-white transition-colors">About Us</a></li>
              <li><a href="#testimonials" className="text-gray-300 hover:text-white transition-colors">Customer Reviews</a></li>
              <li><a href="/blog" className="text-gray-300 hover:text-white transition-colors">Blog</a></li>
              <li><a href="/faq" className="text-gray-300 hover:text-white transition-colors">FAQ</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Cash Home Buying</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Creative Financing</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Probate Solutions</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Foreclosure Help</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Divorce Solutions</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Investment Properties</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-green-400 flex-shrink-0" />
                <div>
                  <a href="tel:1-888-334-3524" className="text-green-400 hover:text-green-300 font-semibold">
                    1-888-334-3524
                  </a>
                  <p className="text-sm text-gray-400">Toll Free - Call or text anytime</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-blue-400 flex-shrink-0" />
                <div>
                  <a href="mailto:info@100doorcapital.com" className="text-blue-400 hover:text-blue-300">
                    info@100doorcapital.com
                  </a>
                  <p className="text-sm text-gray-400">Email us your questions</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <MapPin className="h-5 w-5 text-yellow-400 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">5900 Balcones Dr Ste 100</p>
                  <p className="text-gray-300">Austin, TX 78731</p>
                  <p className="text-sm text-gray-400">Serving nationwide</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <Clock className="h-5 w-5 text-purple-400 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">Monday - Sunday: 8 AM - 5 PM CDT</p>
                  <p className="text-sm text-gray-400">7 days a week</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Service Areas */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <h3 className="text-lg font-bold mb-4 text-center">We Buy Houses in These States</h3>
          <div className="text-center text-gray-400 text-sm">
            <p className="mb-2">
              <strong className="text-white">Currently Operating:</strong> California • Michigan • Ohio • Arkansas • Texas • Georgia • Florida • 
              Tennessee • Alabama • Arizona • Missouri • Hawaii • Maryland • Idaho • Indiana • Colorado • Nevada
            </p>
            <p className="text-green-400 font-medium">
              Don't see your state? Submit anyway to possibly get the best referral for your property!
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 PropertySellEasy.com. All rights reserved.
          </div>
          <div className="flex space-x-6 text-sm">
            <a href="/privacy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</a>
            <a href="/terms" className="text-gray-400 hover:text-white transition-colors">Terms of Service</a>
            <a href="/sitemap" className="text-gray-400 hover:text-white transition-colors">Sitemap</a>
          </div>
        </div>

        {/* Legal Disclaimer */}
        <div className="mt-8 pt-6 border-t border-gray-800 text-xs text-gray-500 text-center">
          <p>
            PropertySellEasy.com is a real estate solutions company. We are not real estate agents or brokers. 
            We buy houses for cash and help homeowners sell their properties quickly. All offers are based on 
            fair market analysis and property condition assessments.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;